import { Col, Row } from 'antd';
import { BaseButton } from 'components/UI/BaseButton';
import { useError } from 'hooks/useError';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { OPERATION_STATUS } from 'util/config/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { ClaimingProcessForm } from './components/ClaimingProcessForm';
import { ClaimingProcessGuides } from './components/ClaimingProcessGuides';
import { ModalClaimingSuccess } from './components/ModalClaimingSuccess';
import { unmountPage } from './state/action';
import * as selector from './state/selector';
import { generateGuides } from './util/guides';

export const ClaimingProcess = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLAIMING_PROCESS);
  const guides = useMemo(() => generateGuides(t), [t]);
  const errorMessagesJson = t('errorCodes', { returnObjects: true });

  useError('10001', errorMessagesJson);
  useError('10002', errorMessagesJson);
  useError('10003', errorMessagesJson);

  const history = useHistory();
  const dispatch = useDispatch();
  const [visibleModal, setVisibleModal] = useState(false);

  const { claimingProcessInfo } = useSelector((state) => ({
    claimingProcessInfo: selector.selectClaimingProcess(state)
  }));

  const handleGoBack = () => {
    history.push('/my-machines');
  };

  useEffect(() => {
    if (claimingProcessInfo.status === OPERATION_STATUS.SUCCESS) {
      setVisibleModal(true);
    }
    if (claimingProcessInfo.error) {
      setTimeout(() => {
        dispatch(unmountPage());
      }, 3000);
    }
  }, [dispatch, claimingProcessInfo.status, claimingProcessInfo.error]);

  return (
    <div className="claiming-process">
      <h2 className="bold">{t('pageTitle')}</h2>
      <Row>
        <Col xs={24} md={12} sm={24} className="claiming-process-header-left">
          <div>
            <h5 className="title">{t('pageRole')}</h5>
          </div>
        </Col>
        <Col xs={24} md={12} sm={24} className="claiming-process-header-right">
          <BaseButton className="go-back-btn" onClick={handleGoBack}>
            {t('goBackButton')}
          </BaseButton>
        </Col>
      </Row>
      <Row className="claiming-process-content">
        <Col xs={24} md={8} sm={24}>
          <ClaimingProcessForm />
        </Col>
        <Col xs={24} md={16} sm={24}>
          {guides.map(({ image, content, id }) => (
            <ClaimingProcessGuides key={id} image={image} content={content} />
          ))}
        </Col>
      </Row>

      <ModalClaimingSuccess visible={visibleModal} />
    </div>
  );
};
